import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
    Checkbox,
    FormControlLabel,
    Typography,
    Box
} from '@mui/material';
import { Button, TextField, Backdrop, CircularProgress } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataRH } from "../../../data/modules/hr-header";
import { useNavigate, useParams } from 'react-router-dom';
import TimeTrackingService from "../../../services/TimeTrackingService";
import Message from "../../tools/Message";
import { LoadingButton } from '@mui/lab';
import Autocomplete from '@mui/material/Autocomplete';
import PlanningMissionService from "../../../services/PlanningMissionService";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function TimeTrackingTous(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const params = useParams();
    const idtime = params.id;
    const [direction,setDirection]=useState([]);
    const [personnel,setPersonnel]=useState([]);
    const [form, setForm] = useState({
        id: '',
        date: '',
        fin:'',
        observation: '',
        users:[]
    });
    const [selectdir,setSelectdir]=useState(null);
    const [isvalidate, setIsvalidate] = useState(true);
    const [isLoading, setIsLoading] = useState(false); 
    const [initialLoading, setInitialLoading] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    
    const { open, color, messageInfo } = message;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prevState => ({
                ...prevState,
                [name]: value
        }));
    };

    const handleChangeutilisateurs = (event, newValue) => {
        setForm(prevState => ({
            ...prevState,
            users: newValue 
        }));
    };

   function handleChangeDirection(event, value) {
        if (value && value.direction_id) {  
            setSelectdir(value);

            TimeTrackingService.listpersonnel(value.direction_id).then((result) => {
                if (result && result.data) {
                    setPersonnel(result.data);
                }
            }).catch((error) => {
                setPersonnel([]); 
            });
        } else {
            setPersonnel([]);  
        }
    }

    
    const handleClick = () => {
        if (form.date === '' || form.observation === '' || form.fin==='') {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: "Veuillez compléter le motif."
            });
            return;
        }
        
        
        const payload = {
            ...form,
            date: form.date,
            observation: form.observation,
            fin:form.fin,
            users:form.users
        };
        
        setIsLoading(true);

        TimeTrackingService.trackingadd(payload)
                .then(handleApiResponse)
                .catch(handleApiError);
        
    };

    const handleApiResponse = (results) => {
        if (results) {
            setMessage({
                ...message, 
                open: true, 
                color: 'green', 
                messageInfo: results.message
            });
            setTimeout(() => {
                navigate('/timetrackingtable');
            }, 1500);
        } else {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: results?.message || "Une erreur est survenue"
            });
        }
        setIsLoading(false);
    };

    const handleApiError = (error) => {
        setMessage({
            ...message,
            open: true,
            color: 'red',
            messageInfo: error.message || "Erreur lors de la communication avec le serveur"
        });
        setIsLoading(false);
    };

    const handleCloseMessage = () => {
        setMessage({...message, open: false});
    };
    
    const formatDate = (dateString) => {
        if (!dateString) return '';
        
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        
        return date.toISOString().split('T')[0];  
    };


    useEffect(() => {
        if (idtime) {
            setInitialLoading(true);
            TimeTrackingService.getByIDTimePrevisionaly(idtime)
                .then((results) => {
                    if (results && results.data) {
                        setIsvalidate(false);
                        const data = results.data;
                        
                        setForm({
                            id: data.timetraking_id,
                            date: formatDate(data.timetraking_date),
                            observation: data.observation
                        });
                    }
                })
                .catch(handleApiError)
                .finally(() => setInitialLoading(false));
        }
    }, [idtime]);

     useEffect(() => {
        
             PlanningMissionService.getDirection().then((result) => {
                      if (result && result.data) {
                          setDirection(result.data);
                      }
            }).catch((error) => {
                      console.error('Error fetching direction data:', error);
            });
    }, []);


    return (
        <MainContainer {...headerDataRH}>
            <Backdrop className={classes.backdrop} open={initialLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            
            <Paper style={{ padding: 20 }}>
                <Grid container spacing={3}>
                     <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Direction :</label>
                     </Grid>
                     <Grid item xs={8}>
                             <Autocomplete
                                onChange={handleChangeDirection}
                                name="direction"
                                options={direction}
                                value={selectdir}
                                getOptionLabel={(option) => `${option.name} (${option.code})`}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        InputProps={{ ...params.InputProps, type: 'search' }}
                                    />
                                )}
                            />  
                    </Grid> 
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Utilisateurs *:</label>
                    </Grid>
                    <Grid item xs={8}>
                        <Autocomplete
                            multiple
                            onChange={handleChangeutilisateurs} 
                            options={personnel || []}
                            value={form.users}
                            getOptionLabel={(option) => option.first_name + " " + option.last_name}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                label="Utilisateurs"
                                size="small"
                                variant="outlined"
                            />
                            )}
                        />
                    </Grid> 
                    {/* Champ Date */}
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Du * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="date"
                            onChange={handleChange}
                            value={form.date}
                            type="date"
                            disabled={initialLoading}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                      <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>au * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="fin"
                            onChange={handleChange}
                            value={form.fin}
                            type="date"
                            disabled={initialLoading}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    {/* Champ Motif */}
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Motif * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="observation"
                            value={form.observation}
                            onChange={handleChange}
                            multiline
                            rows={3}
                            disabled={initialLoading}
                        />
                    </Grid>
                    
                    {/* Bouton Enregistrer */}
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <LoadingButton
                            loading={isLoading} 
                            loadingPosition="center" 
                            variant="contained"
                            color="primary"
                            onClick={handleClick}
                            style={{ fontWeight: 600 }}
                            // disabled={isvalidate || isLoading || initialLoading}
                            fullWidth
                        >
                            ENREGISTRER
                        </LoadingButton>
                    </Grid>
                </Grid>

            </Paper>
        </MainContainer>
    );
}